import styled from "@emotion/styled";
import {
  GridEditInputCell,
  GridRenderEditCellParams,
  useGridApiContext,
} from "@mui/x-data-grid";
import React from "react";
import CurrencyTextField from "../CurrencyTextField";
import appTheme from "../../theme";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";

type MyTheme = Readonly<typeof appTheme>;

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: (theme as MyTheme).palette.error.main,
    color: (theme as MyTheme).palette.error.contrastText,
    zIndex: 99999,
  },
}));

export interface CurrencyEditInputCellProps extends GridRenderEditCellParams {
  currency?: string;
}

function CurrencyEditInputCell(props: CurrencyEditInputCellProps) {
  const { id, value, field, error } = props;
  const apiRef = useGridApiContext();

  const parsedValue = React.useMemo(() => {
    const regexp = /\(?R\$\s(\d{1,3}(\.\d{3})*,\d{2})\)?/;
    const execResult = regexp.exec(value);
    const result = execResult?.[1] ?? "";
    console.log(
      "MEMO:CurrencyEditInputCell parsedValue",
      value,
      execResult,
      result
    );
    return result;
  }, [value]).replace(".", "");

  // const parsedValue = React.useMemo(() => {
  //   // const regex = /\(?(\d{1,3}(\.\d{3})*,\d{2})\)?/;
  //   const regex = /\(?R\$\s(\d{1,3}(\.\d{3})*,\d{2})\)?/;
  //   const result = regex.exec(value);

  //   if (result?.[1]) {
  //     console.log("regex found input", result[1]);
  //     return result[1];
  //   } else {
  //     console.log("regex not found input", value);
  //     return value;
  //   }

  //   // return /\(?R\$\s(\d{1,3}(\.\d{3})*,\d{2})\)?/.exec(value)?.[1] ?? value
  // }, [value]).replace(".", "");

  // console.log("CurrencyEditInputCell", {
  //   id: `${props.field}-${id}`,
  //   value,
  //   parsedValue,
  // });

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // console.log("value change", {
    //   id: `${props.field}-${id}`,
    //   newValue: event.target.value,
    // });
    apiRef.current.setEditCellValue({ id, field, value: event.target.value });
  };

  return (
    <StyledTooltip open={!!error} title={error}>
      <div style={{ width: "100%" }}>
        <CurrencyTextField
          onChange={handleValueChange}
          value={parsedValue}
          currency={props.currency}
          error={!!error}
        />
      </div>
    </StyledTooltip>
  );
}

export default CurrencyEditInputCell;
